import React from "react";
import { Box, Typography, IconButton, Chip } from "@mui/material";
import { DocumentTextIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useTheme } from '@mui/material/styles';

const Header = ({ onClose, subtitle, aiMode = false }) => {
  const theme = useTheme();

  const headerIconBoxSx = {
    width: 37,
    height: 37,
    bgcolor: theme.palette.customSidebar.blue600,
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const headerIconColor = { color: "#fff", width: 20, height: 20 };

  return (
    <Box
      sx={{
        background: "#0f172a",
        color: "#fff",
        px: 3,
        py: 2.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexShrink: 0,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Box sx={headerIconBoxSx}>
          <DocumentTextIcon style={headerIconColor} />
        </Box>
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 400, fontSize: 20, lineHeight: 1.2 }}
            >
              {"Execution Details"}
            </Typography>
            {aiMode && (
              <Chip
                label="AI mode"
                size="small"
                sx={{
                  height: 24,
                  fontWeight: 700,
                  fontSize: 12,
                  bgcolor: "#6366f1",
                  color: "#fff",
                  "& .MuiChip-label": { px: 1.25 },
                }}
              />
            )}
          </Box>
          <Typography sx={{ fontSize: 17, lineHeight: 1.5 }}>
            {subtitle}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <IconButton
          onClick={onClose}
          sx={{
            p: 1,
            color: "#94a3b8",
            "&:hover": { color: "#fff", bgcolor: "#1e293b" },
            borderRadius: 2,
          }}
          title="Close"
        >
          <XMarkIcon style={{ width: 22, height: 22 }} />
        </IconButton>
      </Box>
    </Box>
  );
};


export default Header;
